(() => {
  const ROOT = '[data-klaviyo-list]';
  const REVISION = '2024-10-15';
  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';

  function subscribe(root, email) {
    const company = root.dataset.klaviyoCompany;
    const list = root.dataset.klaviyoList;
    if (!company || !list || !email) return;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: root.dataset.klaviyoSource || 'Newsletter form',
          profile: { data: { type: 'profile', attributes: { email } } },
        },
        relationships: { list: { data: { type: 'list', id: list } } },
      },
    };

    fetch(`${ENDPOINT}?company_id=${encodeURIComponent(company)}`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload),
      keepalive: true,
    })
      .then((response) => {
        if (response.ok) return;
        return response.text().then((text) => {
          throw new Error(`Klaviyo ${response.status}: ${text}`);
        });
      })
      .catch((error) => console.warn('[klaviyo]', error));
  }

  function build(root) {
    if (root.dataset.klaviyoReady) return;

    const form = root.querySelector('form');
    if (!form) return;

    root.dataset.klaviyoReady = 'true';

    form.addEventListener('submit', () => {
      const field = form.querySelector('input[type="email"]');
      const email = field ? field.value.trim() : '';
      if (email) subscribe(root, email);
    });
  }

  function apply(scope = document) {
    scope.querySelectorAll(ROOT).forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));
})();
